import React, { useEffect } from 'react'; 
import InfoCard from '../../compopnents/InfoCard'; 
import FormHead from "../../compopnents/headings/FromHead";
import Styles from "./styles.module.scss";
import Table from '../../compopnents/table/indx';
import { useNavigate } from 'react-router-dom';



function ActivePositions(props: any) {

  useEffect(() => {
    let value = props.data && props.data.length > 0 && props.data.map((item: any) => item.resourceCount = parseInt(item.resourceCount))
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    value = {...props.data, value}
    
  }, [props.data])

  const navigate = useNavigate()
  return (
    <section className="infoCardGrid noHeadCard">
        <InfoCard title="">
          <div className={Styles.infoCardhead}>
            <FormHead>Top Active Positions</FormHead>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a onClick={() => navigate('/positions')} >View all</a>
          </div>
          <div className="dashboardTable">
            <Table type={'activepositions'} status={'active'} data={props.data} />
          </div>
        </InfoCard>
    </section>
  )
}

export default ActivePositions